export default __webpack_public_path__ + "static/media/profile_pic.fda8e9a3.png";